"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOOLBAR_STYLES = exports.TOOLBAR_NAV_TYPES = void 0;
const TOOLBAR_STYLES = exports.TOOLBAR_STYLES = ['solid', 'transparent'];
const TOOLBAR_NAV_TYPES = exports.TOOLBAR_NAV_TYPES = ['arrowKeysOnly', 'tabKeyOnly', 'tabAndArrowsKeys'];